import { motion } from "framer-motion";

export default function LoadingFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background" role="status" aria-label="Carregando aplicacao">
      <motion.div
        className="flex flex-col items-center gap-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <motion.div
          className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent"
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          aria-hidden="true"
        />
        <span className="text-sm text-muted-foreground">Carregando...</span>
      </motion.div>
    </div>
  );
}
